module.exports = __webpack_public_path__ + "img/our-work-01.ab855600.jpg";